import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { DetailPair } from '../../../../../../../shared/components/detail-info-card/DetailPair';
import { DataUtility } from '../../../../../../../utilities/DataUtility';
import { EquifaxDetailCardComponent } from '../equifax-detail-card/equifax-detail-card.component';


@Component({
  selector: 'app-guest-identity-result-card',
  templateUrl: './guest-identity-result-card.component.html',
  styleUrls: ['./guest-identity-result-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    EquifaxDetailCardComponent
  ]
})
export class GuestIdentityResultCardComponent implements OnInit {

  @Input() guest!: any;

  data: DetailPair[] = [];
  title = 'Identity Trust';
  trustDecision!: string;

  identityResolutionReason!: string;
  identityVerificationReason!: string;
  identityRiskReason!: string;

  constructor(private readonly dataUtility: DataUtility) { }

  ngOnInit() {
    this.identityResolutionReason = this.dataUtility.getCheckReason(this.guest, 'identityResolutionReason');
    this.identityVerificationReason = this.dataUtility.getCheckReason(this.guest, 'identityVerificationReason');
    this.identityRiskReason = this.dataUtility.getCheckReason(this.guest, 'identityRiskReason');

    this.populateIdentityTrustInfo();
  }

  populateIdentityTrustInfo() {
    this.trustDecision = this.dataUtility.getTrustInfo(this.guest, 'identityTrust');

    this.data.push(new DetailPair("Resolution", this.dataUtility.getTrustInfo(this.guest, 'identityResolution') ? this.dataUtility.getTrustInfo(this.guest, 'identityResolution') : null, this.identityResolutionReason));
    this.data.push(new DetailPair("Verification", this.dataUtility.getTrustInfo(this.guest, 'identityVerification') ? this.dataUtility.getTrustInfo(this.guest, 'identityVerification') : null, this.identityVerificationReason));
    this.data.push(new DetailPair("Risk", this.dataUtility.getTrustInfo(this.guest, 'identityRisk') ? this.dataUtility.getTrustInfo(this.guest, 'identityRisk') : null, this.identityRiskReason));
  }

}